var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 104,
    viewBox: "0 0 104 104",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 104,
    height: 104,
    rx: 52,
    fill: "#E4EEFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 53.4999C49.6442 54.3611 50.466 55.0737 51.4098 55.5894C52.3536 56.105 53.3973 56.4116 54.47 56.4884C55.5427 56.5653 56.6194 56.4105 57.627 56.0346C58.6347 55.6587 59.5497 55.0705 60.31 54.3099L64.81 49.8099C66.1762 48.3954 66.9321 46.5009 66.9151 44.5344C66.898 42.568 66.1092 40.6869 64.7186 39.2963C63.3281 37.9057 61.447 37.117 59.4805 37.0999C57.514 37.0828 55.6195 37.8388 54.205 39.2049L51.625 41.7699",
    stroke: "#2D65F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M55.0003 50.4998C54.3561 49.6387 53.5343 48.9261 52.5905 48.4104C51.6467 47.8948 50.603 47.5882 49.5303 47.5113C48.4576 47.4345 47.3809 47.5893 46.3733 47.9652C45.3656 48.3411 44.4506 48.9292 43.6903 49.6898L39.1903 54.1898C37.8241 55.6044 37.0682 57.4989 37.0852 59.4654C37.1023 61.4318 37.8911 63.3129 39.2817 64.7035C40.6722 66.0941 42.5533 66.8828 44.5198 66.8999C46.4863 66.917 48.3808 66.161 49.7953 64.7949L52.3603 62.2299",
    stroke: "#2D65F2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/link.34dfcf7ec82c00a715f3c205fb7875f5.svg";
export { ForwardRef as ReactComponent };